import $ = require('jquery');
import DropZone = require('diy/common/js/dd/DropZone');
/**
 * Drop zone using a jquery ui droppable widget, for the navigation items
 *
 * @depends jquery.ui.position.js
 * @depends jquery.ui.droppable.js
 * @depends jquery.expr.position.js
 */

    class NavDropZone extends DropZone {
        activate() {
            super.activate();

            this.element.droppable({
                greedy: true,
                tolerance: 'pointer',
                over: $.proxy(this.onDragOver, this),
                out: $.proxy(this.onDragOut, this),
                drop: $.proxy(this.onDrop, this)
            });
        }

        getDestinationParams() {
            return {
                pageId: this.getPageId()
            };
        }

        getPageId() {
            return parseInt(this.getTargetEl().attr('data-page-id'), 10);
        }

        getMatrixId() {
            let pages = jimdoData.navigation.pages;
            let pageId = this.getPageId();
            for (let i = 0; i < pages.length; i++) {
                /* tslint:disable:triple-equals */
                if (pages[i].pageId == pageId) {
                    let pMatrixes = pages[i].matrixes;
                    for (let matrixId in pMatrixes) {
                        if (pMatrixes[matrixId].defaultDrop) {
                            return matrixId;
                        }
                    }
                }
                /* tslint:enable:triple-equals */
            }
            throw new Error(`No matrix found with defaultDrop flag`);
        }

        deactivate() {
            super.deactivate();

            if (this.element.is(":ui-droppable")) {
                this.element
                    .droppable('destroy');
            }
        }
    }

export = NavDropZone;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/dd/NavDropZone.ts
 **/